import { partial } from 'filesize';
import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React from 'react';
const humanFileSize = partial({
    base: 10,
    round: 1
});
const FileRecord = ({ name, size, error, onRemove })=>{
    const rowClasses = cx('FileInput-row', {
        'FileInput-row--invalid': error
    }, {
        'FileInput-row--valid': !error
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: rowClasses
    }, /*#__PURE__*/ React.createElement("span", {
        className: "FileInput-name"
    }, name), /*#__PURE__*/ React.createElement("span", {
        className: "FileInput-size"
    }, humanFileSize(size)), error ? /*#__PURE__*/ React.createElement("span", {
        className: "FileInput-error"
    }, error) : null, /*#__PURE__*/ React.createElement("button", {
        className: "FileInput-remove",
        onClick: ()=>onRemove(name)
    }, "✖"));
};
FileRecord.propTypes = {
    error: PropTypes.string,
    name: PropTypes.string,
    onRemove: PropTypes.func,
    size: PropTypes.number
};
export default FileRecord;
